export default __webpack_public_path__ + "static/media/ctc2.884dbc66.png";